exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "select[data-v-123a553c]{color:#787878;cursor:pointer}", "", {"version":3,"sources":["/home/runner/work/KeepNeyeVue/KeepNeyeVue/src/components/module/basic-components/regularSelect.vue"],"names":[],"mappings":"AACA,wBACE,cAA0B,AAC1B,cAAgB,CACjB","file":"regularSelect.vue","sourcesContent":["\nselect[data-v-123a553c] {\n  color: rgb(120, 120, 120);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports
